<template>
  <div class="modal fade" :id="id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('access.card.createContact')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body" >
            <div class="row">
              <Select2
                 :parent-id="'#'+id"
                 :is-required="true"
                 container-class="col-12 mb-4"
                 :multiple="false"
                 :show-search="false"
                 :selectClass="'form-select form-control-lg form-select-solid'"
                 :name="'gender'+id"
                 :label="$t('user.gender')"
                 label-class="form-label"
                 :placeholder-text="$t('user.civility')"
                 v-model="formData.gender"
              >
                <option value="female">{{ $t('user.female') }}</option>
                <option value="male">{{ $t('user.male') }}</option>
              </Select2>
              <div class="col-12 mb-4">
                <label class="required mb-3">{{ $t("contacts.lastname") }}</label>
                <input type="text" v-model="formData.lastname" class="form-control form-control-solid" :placeholder="$t('contacts.lastname')" required>
              </div>
              <div class="col-12 mb-4">
                <label class="required mb-3">{{ $t("contacts.firstname") }}</label>
                <input type="text" v-model="formData.firstname" class="form-control form-control-solid" :placeholder="$t('contacts.firstname')" required>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import Select2 from "@/components/Select2.vue";

const store = useStore()

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  parentId: {
    type: String,
    required: false,
  }
})
const emits = defineEmits(['callback'])

const formData = ref({
  gender: '',
  lastname: "",
  firstname: ""
})
const isLoading = ref(false)


function closeModal(){
  if (props.parentId) {
    $('#'+props.parentId).modal('toggle');
  }
  $('#'+props.id).modal('hide');
  resetForm();
}

function resetForm() {
  formData.value = {
    gender: '',
    lastname: "",
    firstname: ""
  };
}


function submitData(){
  isLoading.value = true;

  store.dispatch('contacts/createContact', {...formData.value, contactType: 'particular'})
      .then((response) => {
        window.toastr['success'](i18n.global.t( 'notification.contact_created'));
        closeModal()
        emits('callback', response?.data?.contact?.id)
      })
      .catch(err => {})
      .finally(() => isLoading.value = false)
}


</script>